import { MouseEvent } from 'react';
import Image from 'global/Image';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import useMultiPortfolioStore from 'lib/stores/multiPorto';
import {
  Container,
  ContentWrapper,
  Description,
  FinishButton,
  Title,
} from '../CreateSuccess/success.styled';

const CreatePortoError = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const cannotCreateData = useMultiPortfolioStore(
    (s) => s.subAccountsData.data?.can_not_create_new_sub_account_reason,
  );

  const handleSubmit = () => {
    onSubmit();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
  };

  return (
    <BaseSecuritiesModal
      hideSubmit
      onCancel={handleCancel}
      className="modal-multi-porto error"
      transitionName=""
      {...props}
    >
      <Container
        onClick={(e) => e.stopPropagation()}
        className="error-create-porto"
      >
        <Image src="/images/multi-porto/error-create-porto.svg" alt="" />

        <ContentWrapper>
          <Title>{cannotCreateData?.title}</Title>
          <Description>{cannotCreateData?.description}</Description>
        </ContentWrapper>

        <FinishButton onClick={handleSubmit} type="primary">
          OK
        </FinishButton>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default CreatePortoError;
